import { render, staticRenderFns } from "./unifiedPurchaseRequest.vue?vue&type=template&id=4e85e651"
import script from "./unifiedPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./unifiedPurchaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports